import PencilCircleFill from './PencilCircleFill';

export default PencilCircleFill;
